import { useMutation } from "react-query";
import type { Step4Response } from "Types/Cart";
import { showValidationErrors } from "../Utils/Error";
import { useTunnel } from "Hooks";

export const useHandleTransportOptionsChangeMutation = (requestValidator, mutateAsync) => {
  const { getTunnel } = useTunnel();

  return useMutation(
    async (updatedTransportOptions: number[]) => {
      const tunnel = getTunnel() as Partial<Step4Response>;

      const request = {
        ...tunnel,
        step4: {
          ...tunnel.step4,
          // Reset dates if transport options change, otherwise they might not be valid anymore
          exactDates: updatedTransportOptions.length > 0,
          depositDate: null,
          pickupDate: null,
        },
        transportOptions: updatedTransportOptions,
      };

      const validatedRequest = await requestValidator.validate(request);
      await mutateAsync(validatedRequest);
    },
    {
      onError: (err) => {
        showValidationErrors(err);
      },
    },
  );
};

export default useHandleTransportOptionsChangeMutation;
